import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { ZtTableHeaderType } from '../zt-table/zt-table.model';
import {
    ZtFilterChangeEvent,
    ZtFilterConfig,
    ZtFilterEvent,
} from './zt-filter.model';

@Component({
    selector: 'zt-filter',
    templateUrl: 'zt-filter.component.html',
})
export class ZtFilterComponent implements OnInit {
    @Input() configuration: ZtFilterConfig | undefined = undefined;

    @Output() filterChange = new EventEmitter<ZtFilterEvent>();

    constructor() {}

    ngOnInit(): void {}

    get ZtTableHeaderType(): typeof ZtTableHeaderType {
        return ZtTableHeaderType;
    }

    onFilterChange(event: ZtFilterChangeEvent) {
        if (!this.configuration) {
            return;
        }

        this.filterChange.emit({
            key: this.configuration.key,
            eventType: event.type,
            dataType: this.configuration.type,
            data: event.data,
        });
    }
}
